import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import {
  delOrganizationUser,
  getSubOrganizationUser,
  getUploadData,
  organizationExDownload,
  updtOrganizationUser,
} from 'services/api-service/center';
import { utilService } from 'services/util-service';
import { IUser } from 'store/modules/user';
import ModalDelete from './ModalDelete';

const ManagerRescue = ({ userInfo }: IUser) => {
  const [selected, setSelected] = useState(undefined);
  const [group, setGroup] = useState({
    first: '서해청',
    firstIndex: 2,
    second: '완도',
    secondIndex: 4,
    third: '마량파출소',
    thirdIndex: 117,
  });
  const [searchFilter, setSearchFilter] = useState({
    category: 'nm', // nm(이름), ph(전화번호), sp(구조대분류)
    keyword: '',
  });
  const [datas, setDatas] = useState<any[] | undefined>(undefined);
  const [rescues, setRescues] = useState<any[] | undefined>(undefined);
  const [openDelete, setOpenDelete] = useState<any>(undefined);
  const [register, setRegister] = useState({
    name: '',
    addr: null,
    country: null,
    gender: null,
    levelIdx: '',
    phone: '',
    resiDate: null,
    resiNum: null,
    special1: '',
    special2: '',
    userIdx: '',
    vesselYn: null,
  });
  const hasPermission = userInfo.belong === group.third || userInfo.role === 'S';

  const getOrganizations = async () => {
    try {
      const response: any = await getUploadData();
      if (response.result === 'success') {
        const dataList = response.dataList;
        setDatas(dataList);
        const findPathWithIndex = (nodes: any[], target: string, path: any[] = []): any => {
          for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const currentPath = [...path, { ...node, arrayIndex: i }];

            if (node.label && node.label.includes(target)) {
              return currentPath;
            }

            if (node.children && node.children.length > 0) {
              const foundPath = findPathWithIndex(node.children, target, currentPath);
              if (foundPath) return foundPath;
            }
          }
          return null;
        };
        if (userInfo.role === 'S') {
          getRescues(group.thirdIndex);
        } else {
          const resultPath = findPathWithIndex(dataList, userInfo.belong);
          if (resultPath) {
            const lv1 = resultPath[0];
            const lv2 = resultPath[1];
            const lv3 = resultPath[2];
            setGroup({
              first: lv1?.label || '',
              firstIndex: lv1 !== undefined ? lv1.arrayIndex : 0,
              second: lv2?.label || '',
              secondIndex: lv2 !== undefined ? lv2.arrayIndex : 0,
              third: lv3?.label || '',
              thirdIndex: lv3?.value || 0,
            });
            getRescues(lv3?.value);
          }
        }
      }
    } catch (error) {
      console.error('getOrganizations Error:', error);
    }
  };

  const getRescues = async (index: number | null) => {
    try {
      const response: any = await getSubOrganizationUser(index, searchFilter.category, searchFilter.keyword);
      if (response.result === 'success') {
        setRescues(response.datas);
      }
    } catch (error) {
      console.log('getRescues Error ', error);
    }
  };

  const onCloseDelete = async (item: any) => {
    if (item) {
      const success = await onDelete(item);
      if (success) setOpenDelete(undefined);
    } else {
      setOpenDelete(undefined);
    }
  };

  const onRegister = async (item: any, isClear: boolean) => {
    if (utilService.isEmpty(item.special1)) {
      return toast('구조대를 입력 바랍니다.', { type: 'error' });
    } else if (utilService.isEmpty(item.phone) || item.phone.length < 11) {
      return toast('전화번호를 정확히 입력해 주세요', { type: 'error' });
    } else if (utilService.isEmpty(item.special2)) {
      return toast('구조대 분류를 정확히 입력해 주세요', { type: 'error' });
    } else if (utilService.isEmpty(item.name)) {
      return toast('이름을 정확히 입력해 주세요.', { type: 'error' });
    }

    const purePhone = item.phone.replace(/-/g, '');
    if (isClear) {
      try {
        const response: any = await updtOrganizationUser(
          undefined,
          item.name,
          purePhone,
          item.resiNum,
          item.gender,
          item.country,
          item.addr,
          item.vesselYn,
          group.first,
          group.second,
          group.third,
          group.thirdIndex,
          item.special1,
          item.special2,
          item.resiDate
        );
        if (response.result === 'success') {
          setRegister({
            name: '',
            addr: null,
            country: null,
            gender: null,
            levelIdx: '',
            phone: '',
            resiDate: null,
            resiNum: null,
            special1: '',
            special2: '',
            userIdx: '',
            vesselYn: null,
          });
          setSelected(undefined);
          getRescues(group.thirdIndex);
          return toast('등록되었습니다.', { type: 'success' });
        } else {
          return toast(response.error_msg, { type: 'error' });
        }
      } catch (error) {
        console.log('onRegister Error ', error);
      }
    } else {
      try {
        const response: any = await updtOrganizationUser(
          item.userIdx,
          item.name,
          purePhone,
          item.resiNum,
          item.gender,
          item.country,
          item.addr,
          item.vesselYn,
          group.first,
          group.second,
          group.third,
          group.thirdIndex,
          item.special1,
          item.special2,
          item.resiDate
        );
        if (response.result === 'success') {
          setSelected(undefined);
          getRescues(group.thirdIndex);
          return toast('등록되었습니다.', { type: 'success' });
        }
      } catch (error) {
        console.log('onRegister Error ', error);
      }
    }
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  const onSearch = async () => {
    setSelected(undefined);
    // Search
    getRescues(group.thirdIndex);
  };

  const onDownload = async () => {
    try {
      const res: any = await organizationExDownload();
      const blob = new Blob([res.data]);
      const fileUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.style.display = 'none';

      const injectFilename = (res: any) => {
        const disposition = res.headers['content-disposition'];
        const fileName = decodeURI(disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1].replace(/['"]/g, ''));
        return fileName;
      };
      link.download = injectFilename(res);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast('권한 확인 후 다운로드 바랍니다.', { type: 'success' });
    }
  };

  const onModify = async (item: any) => {
    if (selected === item.userIdx) {
      // Register
      onRegister(item, false);
    } else {
      setSelected(item.userIdx);
    }
  };

  const onDelete = async (item: any) => {
    try {
      const response: any = await delOrganizationUser(item.userIdx);
      if (response.result === 'success') {
        getRescues(group.thirdIndex);
        return toast('구조대원을 삭제하였습니다.', { type: 'success' });
      }
    } catch (error) {
      console.log('onDelete Error ', error);
    }
  };

  const onChangeGroup = (e: any) => {
    const { name, value, selectedIndex } = e.target;
    // console.log('onChangeGroup  ', name, value, selectedIndex);
    if (name === 'first') {
      setGroup({
        ...group,
        [name]: value,
        [name + 'Index']: selectedIndex,
        ['second']: datas![selectedIndex].children[0].value,
        ['secondIndex']: 0,
        ['third']: datas![selectedIndex].children[0].children[0].label,
        ['thirdIndex']: datas![selectedIndex].children[0].children[0].value,
      });
    } else if (name === 'second') {
      setGroup({
        ...group,
        [name]: value,
        [name + 'Index']: selectedIndex,
        ['third']: datas![group.firstIndex].children[selectedIndex].children[0].label,
        ['thirdIndex']: datas![group.firstIndex].children[selectedIndex].children[0].value,
      });
    } else {
      // find userIdx
      setGroup({
        ...group,
        [name]: datas![group.firstIndex].children[group.secondIndex].children[selectedIndex].label,
        [name + 'Index']: datas![group.firstIndex].children[group.secondIndex].children[selectedIndex].value,
      });
    }
  };

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;

    setRegister((prev) => ({
      ...prev,
      [name]: name === 'phone' ? utilService.formatPhoneNumber(value) : value,
    }));
  };

  const onModifyHandler = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = event.target;

    setRescues((prev) =>
      prev?.map((item) =>
        item.userIdx === selected
          ? {
              ...item,
              [name]: name === 'phone' ? utilService.formatPhoneNumber(value) : value,
            }
          : item
      )
    );
  };

  useEffect(() => {
    getOrganizations();
  }, []);

  return (
    <ManagerRescueTemplateWrap>
      <TitleWrap>해양재난구조대원 관리</TitleWrap>
      <SearchWrap>
        <SearchRow>
          <SelectGroup onChange={onChangeGroup} name="first" value={group.first || ''}>
            {datas &&
              datas.map((data, index) => (
                <option key={index} value={data.value}>
                  {data.label}
                </option>
              ))}
          </SelectGroup>
          <SelectGroup onChange={onChangeGroup} name="second" value={group.second || ''}>
            {datas &&
              datas[group.firstIndex]?.children.map((first, index) => (
                <option key={index} value={first.value}>
                  {first.label}
                </option>
              ))}
          </SelectGroup>
          <SelectGroup onChange={onChangeGroup} name="third" value={group.third || ''}>
            {datas &&
              datas[group.firstIndex]?.children[group.secondIndex]?.children.map((second, index) => (
                <option key={index} value={second.label}>
                  {second.label}
                </option>
              ))}
          </SelectGroup>
        </SearchRow>

        <SearchRow>
          <SelectGroup
            value={searchFilter.category}
            onChange={(e) => setSearchFilter({ ...searchFilter, category: e.target.value })}
          >
            <option value="nm">이름</option>
            <option value="ph">전화번호</option>
            <option value="sp">구조대 분류</option>
          </SelectGroup>
          <SearchInput
            placeholder={
              searchFilter.category === 'nm'
                ? '이름으로 검색하세요.'
                : searchFilter.category === 'ph'
                ? '전화번호 11자리를 입력하여 검색하세요.'
                : '선박명 및 보유장비를 검색하세요.'
            }
            value={searchFilter.keyword}
            onChange={(e) => setSearchFilter({ ...searchFilter, keyword: e.target.value })}
            onKeyDown={onKeyDown}
          />
          <SearchButton onClick={onSearch}>검색</SearchButton>
        </SearchRow>
      </SearchWrap>
      <RegisterWrap>
        <table>
          <tbody>
            <tr>
              <th style={{ width: '13rem' }}>
                <SelectWrap
                  name="special1"
                  value={register.special1 || ''}
                  onChange={onChangeHandler}
                  disabled={!hasPermission}
                >
                  <option value="" hidden>
                    선택하세요
                  </option>
                  <option value="선박구조대">선박구조대</option>
                  <option value="비선박구조대">비선박구조대</option>
                </SelectWrap>
              </th>
              <th style={{ width: '10rem' }}>
                <RegisterInputWrap
                  name="name"
                  type="text"
                  value={register.name || ''}
                  placeholder="이름"
                  onChange={onChangeHandler}
                  disabled={!hasPermission}
                />
              </th>
              <th style={{ width: '13rem' }}>
                <RegisterInputWrap
                  name="phone"
                  type="text"
                  value={register.phone || ''}
                  placeholder="전화번호"
                  onChange={onChangeHandler}
                  disabled={!hasPermission}
                />
              </th>
              <th style={{ width: '18rem' }}>
                <RegisterInputWrap
                  name="special2"
                  type="text"
                  value={register.special2 || ''}
                  placeholder="구조대 분류"
                  onChange={onChangeHandler}
                  disabled={!hasPermission}
                />
              </th>
              <th style={{ width: '10rem' }}>
                <RegisterButton disabled={!hasPermission} onClick={() => onRegister(register, true)}>
                  등록
                </RegisterButton>
              </th>
            </tr>
          </tbody>
        </table>
      </RegisterWrap>
      <TableWrap>
        <table>
          <thead>
            <tr>
              <th style={{ width: '5rem' }}>No.</th>
              <th style={{ width: '12rem' }}>구조대</th>
              <th style={{ width: '7rem' }}>이름</th>
              <th style={{ width: '12rem' }}>전화번호</th>
              <th style={{ width: '20rem' }}>구조대 분류</th>
              <th style={{ width: '12rem' }}>수정 / 삭제</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(rescues) && rescues.length === 0 ? (
              <tr>
                <th style={{ height: '10rem' }}>구조대 정보가 없습니다.</th>
              </tr>
            ) : (
              rescues !== undefined &&
              rescues.map((item, index) => (
                <tr key={index}>
                  <td style={{ width: '5rem' }}>{index + 1}</td>
                  <td style={{ width: '12rem' }}>
                    {selected === item.userIdx ? (
                      <SelectWrap as="select" name="special1" value={item.special1 || ''} onChange={onModifyHandler}>
                        <option value="선박구조대">선박구조대</option>
                        <option value="비선박구조대">비선박구조대</option>
                      </SelectWrap>
                    ) : (
                      <InputWrap
                        type="text"
                        name="special1"
                        value={item.special1}
                        disabled={true}
                        onChange={onModifyHandler}
                      />
                    )}
                  </td>
                  <td style={{ width: '7rem' }}>
                    <InputWrap
                      type="text"
                      name="name"
                      value={item.name}
                      disabled={selected !== item.userIdx}
                      onChange={onModifyHandler}
                    ></InputWrap>
                  </td>
                  <td style={{ width: '12rem' }}>
                    <InputWrap
                      type="text"
                      name="phone"
                      value={utilService.formatPhoneNumber(item.phone)}
                      disabled={selected !== item.userIdx}
                      onChange={onModifyHandler}
                      maxLength={13}
                    ></InputWrap>
                  </td>
                  <td style={{ width: '20rem' }}>
                    <InputWrap
                      type="text"
                      name="special2"
                      value={item.special2}
                      disabled={selected !== item.userIdx}
                      onChange={onModifyHandler}
                    ></InputWrap>
                  </td>
                  <td style={{ width: '12rem' }}>
                    <ModifyButton disabled={!hasPermission} onClick={() => onModify(item)}>
                      {selected === item.userIdx ? '등록' : '수정'}
                    </ModifyButton>
                    <DeleteButton disabled={!hasPermission} onClick={() => setOpenDelete(item)}>
                      삭제
                    </DeleteButton>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </TableWrap>
      {openDelete && <ModalDelete item={openDelete} onClose={onCloseDelete} />}
    </ManagerRescueTemplateWrap>
  );
};

const ManagerRescueTemplateWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;
const TitleWrap = styled.div`
  text-align: center;
  align-content: center;
  width: 18.75rem;
  height: 3.4375rem;
  cursor: pointer;
  background: radial-gradient(#cf1900, #000000);
  border-radius: 0.625rem;
  border: 1px solid;
  border-color: #cf1900;
  color: #ffffff;
  font-family: Inter;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  margin: 4rem auto;
`;
const SearchWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 90%;
  min-width: 68.0625rem;
  margin: 0 auto 20px;
  padding: 25px;
  background: #011f3c;
  border-radius: 15px;
  align-items: center;
`;
const SearchRow = styled.div`
  display: flex;
  gap: 30px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
const SelectGroup = styled.select`
  width: 200px;
  height: 36px;
  font-size: 1rem;
  text-align: center;
  color: #99bcdc;
  background: #012f5a;
  border-radius: 8px;
  border: 1px solid #547d9a;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white' %3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 20px;
`;
const SearchInput = styled.input`
  width: 300px;
  height: 36px;
  background: #668caf;
  border-radius: 8px;
  border: 1px solid #bed8ef;
  color: white;
  padding: 0 15px;
  font-size: 1rem;
  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
`;
const RegisterWrap = styled.div`
  width: 90%;
  min-width: 68.0625rem;
  height: 4.25rem;
  margin: 20px auto;
  padding: 15px 45px;
  background: #011f3c;
  border-radius: 10px;
  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  th {
    width: 100%;
    height: 2rem;
    color: #fff;
    // border: 1px solid #547d9a;
  }
`;
const TableWrap = styled.div`
  width: 90%;
  min-width: 68.0625rem;
  max-height: 36.575rem;
  border: 1px solid #547d9a;
  // overflow-y: auto;
  margin: auto;
  background: linear-gradient(180deg, #002f5a 0%, #000 100%);

  thead {
    display: block;
    table-layout: fixed;
  }

  tbody {
    max-height: 33.075rem;
    table-layout: fixed;
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
    // margin: 0 5px 0 5px;
    ::-webkit-scrollbar {
      // display: none;
      width: 3px;
    }
    ::-webkit-scrollbar-thumb {
      height: 10%; /* 스크롤바의 길이 */
      background: #0086ff; /* 스크롤바의 색상 */

      border-radius: 10px;
    }
    ::-webkit-scrollbar-track {
      background: rgba(33, 122, 244, 0.1); /*스크롤바 뒷 배경 색상*/
    }
  }

  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    border-bottom: 1px solid #547d9a;
  }
  th {
    width: 100%;
    height: 3.25rem;
    color: #fff;
    border: 1px solid #547d9a;
    vertical-align: middle;
  }
  td {
    vertical-align: middle;
    height: 3.25rem;
    margin: 0;
    color: #fff;
    text-align: center;
    font-family: Inter;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border: 1px solid #547d9a;
    cursor: pointer;
    :last-child {
      border-right: 0;
    }
  }
`;
const InputWrap = styled.input`
  width: 80%;
  height: 2.25rem;
  color: #ffffff;
  background: #668caf;
  border: 1px solid #bed8ef;
  text-align: center;
  border-radius: 5px;
  font-size: 1rem;
  ::placeholder {
    color: #ffffff;
  }
  :disabled {
    background: transparent;
    border: none;
  }
`;
const RegisterInputWrap = styled.input`
  width: 80%;
  height: 2.25rem;
  color: #ffffff;
  background: #668caf;
  border: 1px solid #bed8ef;
  text-align: center;
  border-radius: 5px;
  font-size: 1rem;
  ::placeholder {
    color: #ffffff;
  }
  &:disabled {
    background: #444;
    border: 1px solid #666;
    color: #999;
    cursor: not-allowed;
    opacity: 0.7;
    text-shadow: none;
    box-shadow: none;
    ::placeholder {
      color: #777;
    }
  }
`;
const SelectWrap = styled(RegisterInputWrap.withComponent('select'))`
  appearance: auto;
  padding: 0 5px;
  color: ${(props) => (props.value === '' ? '#cccccc' : '#ffffff')};
  option {
    background-color: #668caf;
    color: #ffffff;
  }
  option[hidden] {
    display: none;
  }
`;
const ModifyButton = styled.button`
  width: 70px;
  height: 2.25rem;
  background: #176693;
  border: 2px solid #4f7da7;
  border-radius: 0.625rem;
  color: #fff;
  cursor: pointer;
  &:disabled {
    background: #555;
    border-color: #777;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
const DeleteButton = styled(ModifyButton)`
  margin-left: 1rem;
  background: #763c51;
  border: 2px solid #af6666;
`;
const RegisterButton = styled(ModifyButton)`
  width: 70px;
  height: 2.25rem;
  margin-left: 1rem;
  background: #3c5a76;
  border: 2px solid #668caf;
`;
const SearchButton = styled(ModifyButton)`
  width: 6.25rem;
  height: 2.25rem;
  background: #1760a6;
  border: 2px solid #4f7da7;
`;
const DownloadButton = styled(ModifyButton)`
  width: 9.25rem;
  height: 2.25rem;
  margin-left: 5rem;
  background: #3c5a76;
  border: 2px solid #668caf;
  &:disabled {
    background: #b0b8c1;
    border-color: #c0c8d0;
    color: #e0e0e0;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export default ManagerRescue;
